import React from "react";

function CircleLoader() {
  return (
    <div className="spinner-wrap bg-light">
      <div className="spinner-border custom-spinner-color" />
    </div>
  );
}

export default CircleLoader;
